module.exports = __webpack_public_path__ + "static/media/view-all.4db14840.svg";